import { Box, Center, Stack, Heading } from "@chakra-ui/react";
import { useContaxt } from "../context/Context";

export function HeadLine({
  text,
  size = ["25px", "25px", "32px", "35px", "45px"],
  as = "h2"
}) {
  const { color } = useContaxt();
  return (
    <Center>
      <Stack>
        <Heading as={as} textAlign={"center"} fontSize={size}>
          {text}
        </Heading>
        <Center>
          <Box w={"60%"} h={1} bgColor={color.mainColor} />
        </Center>
      </Stack>
    </Center>
  );
}
